import api from "../../../api";
import urls from "../../../urls";

export async function checkSubMeteringConnection(configurationId: number) {
  const res = await api.get<void | { error: string }>(
    urls.api.checkSubMeteringConnection(configurationId)
  );
  return res;
}
